import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import { ErrorMessage } from "formik";
import { DescriptionInputProps } from "./description-input-props";
import "./description-input-component.scss";

const DescriptionInputComponent: React.FC<DescriptionInputProps> = ({
  fieldName,
  placeholder = "Add Description",
  optional = false,
  disabled,
  value,
  onChange,
  minlength,
  maxlength,
  rows = 4,
  renderErrorMessage = true,
}) => {
  return (
    <Box>
      <div className="description-input-component">
        <FormControl>
          <TextField
            name={fieldName}
            placeholder={placeholder}
            required={optional}
            disabled={disabled}
            id={fieldName}
            value={value}
            onChange={onChange}
            multiline
            minRows={1}
            maxRows={rows}
            variant="outlined" // Using 'outlined' to ensure SCSS styles apply
            InputLabelProps={{ shrink: true }} // Forces label to stay above
            inputProps={{
              minLength: minlength,
              maxLength: maxlength,
            }}
          />
        </FormControl>
         {renderErrorMessage && <ErrorMessage
          name={fieldName ?? ""}
          component="div"
          className="error-message"
        />}
      </div>
    </Box>
  );
};

export default DescriptionInputComponent;
